module.exports = __webpack_public_path__ + "static/palmas-tocantins-a952573b91328f84162b5d983b901890.jpg";